import moment from 'moment'

const dateLatin = (value) => {

    if (value) {
        let count = value.split("T").length

        if ( count === 1 )  return moment(value).format('DD/MM/YYYY')
        else return moment(value).format('DD/MM/YYYY H:mm')
    }
}

export default dateLatin